import { useContext } from 'react';
import { simulationDataBuyAndSellContext } from './context';

export const useSimulationDataBuyAndSellContext = () => {
  const context = useContext(simulationDataBuyAndSellContext);
  return context;
};
